import { Device } from '@twilio/voice-sdk';

const setupTwilioDevice = (thisObj, twilioToken, notificationFunction) => {
  let device = new Device(twilioToken, {
    codecPreferences: ["opus", "pcmu"],
    fakeLocalDTMF: true,
    enableRingingState: true,
    closeProtection: true
  });

  device.on("registered", () => {
    console.log("Twilio.Device Ready!");
    thisObj.setState({ twilioStatus: 'ready', device, connectionFunction: undefined });
  });

  device.on("error", (error) => {
    console.log("Twilio.Device Error: " + error.message);
    thisObj.setState({ twilioStatus: 'error', connectionFunction: undefined })
  });

  // Note: In SDK v2, there's no 'connect' event on device.
  // The 'accept' event is now on the Call object itself.
  // We'll handle call setup in the phone widget after device.connect() returns.

  // Note: In SDK v2, disconnect is handled on individual Call objects

  device.on("incoming", (call) => {
    console.log(call)
    console.log("Incoming support call");

    notificationFunction("Incoming Call!" ,`Call from ${call.parameters.From}`);
    
    // Set up event handlers for this call
    call.on('accept', () => {
      console.log('Incoming call accepted');
      thisObj.setState({ 
        twilioStatus: 'connect', 
        activeCall: call,
        sendDigits: (d) => call.sendDigits(d)
      });
    });
    
    call.on('disconnect', () => {
      console.log('Call disconnected');
      thisObj.setState({ 
        twilioStatus: 'ready', 
        activeCall: null,
        connectionFunction: undefined,
        sendDigits: undefined
      });
    });

    // Set a callback on the answer button and enable it
    function cf() {
      call.accept();
    }

    function rf() {
      call.reject();
      thisObj.setState({ twilioStatus: 'ready' })
    }

    thisObj.setState({ twilioStatus: 'incoming', connectionFunction: cf, rejectFunction: rf, activeCall: call })
  });

  // Register the device with Twilio
  device.register();
  
  return device;
};

export default setupTwilioDevice;

